import { render } from "./ContactGrideComponent.vue?vue&type=template&id=7c20a96e&scoped=true"
import script from "./ContactGrideComponent.vue?vue&type=script&lang=js"
export * from "./ContactGrideComponent.vue?vue&type=script&lang=js"

import "./ContactGrideComponent.vue?vue&type=style&index=0&id=7c20a96e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c20a96e"]])

export default __exports__